import { AvailableOptions, FilterValueTypes, StringFilterOption } from '@access-erp/ui-components';

import { BILLING_SUB_MENU } from './useDefaultGridFilter';

export const salesOrderTypesFormatted: Record<string, string> = {
  SalesOrder: 'Sales Order',
  Proforma: 'Proforma',
};

export const failedSalesOrderStatuses = [
  { label: 'Sending Stopped', value: 'Sending Stopped' },
  { label: 'Sending Failed', value: 'Sending Failed' },
  { label: 'Sending Scheduling Failed', value: 'Sending Scheduling Failed' },
];

export const pausedSalesOrderStatuses = [{ label: 'Billing Paused', value: 'Billing Paused' }];

export const sentSalesOrderStatuses = [{ label: 'Sent', value: 'Sent' }];

export const scheduledSalesOrderStatuses = [
  { label: 'Sending Paused', value: 'Sending Paused' },
  { label: 'Sending Scheduled', value: 'Sending Scheduled' },
];

export const billingTypes = [
  { label: salesOrderTypesFormatted.SalesOrder, value: 'SalesOrder' },
  { label: salesOrderTypesFormatted.Proforma, value: 'Proforma' },
];

export const salesOrderSourceTypes = [
  { label: 'System', value: 'System' },
  { label: 'Manual', value: 'Manual' },
];

export const allSalesOrderStatuses = [
  ...failedSalesOrderStatuses,
  ...sentSalesOrderStatuses,
  ...scheduledSalesOrderStatuses,
  { label: 'Created', value: 'Created' },
];

export const guidFilterOptions: AvailableOptions<FilterValueTypes.StringFilter> = [
  StringFilterOption.Eq,
  StringFilterOption.Ne,
];

const submenu_filter_statuses = {
  [BILLING_SUB_MENU.FAILED]: failedSalesOrderStatuses,
  [BILLING_SUB_MENU.PAUSED]: pausedSalesOrderStatuses,
  [BILLING_SUB_MENU.SCHEDULED]: scheduledSalesOrderStatuses,
  [BILLING_SUB_MENU.SENT]: sentSalesOrderStatuses,
};

export const extractSubMenuStatusFilters = (isBillingBCPath: any) => {
  const subpage = Object.keys(submenu_filter_statuses).find((status) =>
    window.location.pathname.includes(status),
  );
  if (subpage) return submenu_filter_statuses[subpage as keyof typeof submenu_filter_statuses];
  else return [...allSalesOrderStatuses, ...(isBillingBCPath ? pausedSalesOrderStatuses : [])];
};
